module.exports = __webpack_public_path__ + "static/media/PF_Din_Mono_W01_Regular.b55fabb6.woff2";